export const actions = {
    STORE_SUBMITTED_MESSAGE_DATA: "STORE_SUBMITTED_MESSAGE_DATA",
    STORE_UNSUBMITTED_MESSAGE_DATA: "STORE_UNSUBMITTED_MESSAGE_DATA",
};

export const initialState = {
    submittedFetching: true,
    unsubmittedFetching: true,
    submitted: {},
    unsubmitted: {},
};

export default (state = initialState, { type, messages }) => {
    switch (type) {
        case actions.STORE_SUBMITTED_MESSAGE_DATA: {
            return {
                ...state,
                submittedFetching: false,
                submitted: messages,
            };
        }
        case actions.STORE_UNSUBMITTED_MESSAGE_DATA: {
            return {
                ...state,
                unsubmittedFetching: false,
                unsubmitted: messages,
            };
        }

        default:
            return state;
    }
};
